import { ErrorHandler, inject, Injectable, ɵRuntimeError } from "@angular/core"
import { Router } from "@angular/router"

import { MessageService } from "primeng/api"

import { lgklog } from "@logick/common/logger"
import {ApiError} from "@logick/core-api"
import { LgkProgressSpinner } from "@logick/ui/progress-spinner"

@Injectable({
    providedIn: "root"
})
export class GlobalErrorHandler extends ErrorHandler {

    private loader = inject(LgkProgressSpinner, {optional:true})
    private messageService = inject(MessageService)
    private router = inject(Router)

    async handlePromise<T>(promise: Promise<T>): Promise<T> {
        return promise.catch((err) => { this.handleError(err); return Promise.reject() })
    }

    private static readonly CHUNK_RELOAD_KEY = "lgk_chunk_reload"

    private isChunkLoadError(error: any): boolean {
        const msg: string = error?.message ?? ""
        return (
            error?.name === "ChunkLoadError" ||
            msg.includes("Loading chunk") ||
            msg.includes("Loading CSS chunk") ||
            msg.includes("dynamically imported module") ||
            msg.includes("Failed to fetch dynamically imported module") ||
            msg.includes("error loading dynamically imported module")
        )
    }

    private handleChunkLoadError(): void {
        const alreadyRetried = sessionStorage.getItem(GlobalErrorHandler.CHUNK_RELOAD_KEY)
        if (!alreadyRetried) {
            sessionStorage.setItem(GlobalErrorHandler.CHUNK_RELOAD_KEY, "1")
            window.location.reload()
        } else {
            sessionStorage.removeItem(GlobalErrorHandler.CHUNK_RELOAD_KEY)
            this.messageService.add({
                severity: "warn",
                summary: "Mise à jour disponible",
                detail: "Une nouvelle version de l'application est disponible. Veuillez recharger la page.",
                life: 0,
                closable: true
            })
        }
    }

    override handleError(error: any): void {
        this.loader?.hide()
        if (this.isChunkLoadError(error)) {
            this.handleChunkLoadError()
            return
        }
        if (error instanceof ɵRuntimeError) this.handleRuntimeError(error)
        if (error instanceof ApiError)  this.handleApiError(error)
        else this.handleUnknownError(error)
        lgklog.error("GlobalErrorHandler", error)
    }

    handleApiError(error: ApiError): void {/* on ne fait rien */}


    handleRuntimeError(error: ɵRuntimeError): void {
        this.messageService.add({
            severity: "warn",
            summary: "Attention",
            detail: "La fonctionnalité n'est pas accessible",
            life: 5000,
            closable: true
        })
    }

    handleUnknownError(error: any): void {
        this.messageService.add({
            severity: "error",
            summary: "Problème",
            detail: `${error?.message}`,
            life: 5000,
            closable: true
        })
      
        this.router.navigate(["error"])
    }
}